import { render, staticRenderFns } from "./PanelModalOptionsForm.vue?vue&type=template&id=2c5c7c4d&scoped=true&"
import script from "./PanelModalOptionsForm.vue?vue&type=script&lang=js&"
export * from "./PanelModalOptionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5c7c4d",
  null
  
)

export default component.exports